// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Eatn","title":"styles_title__2JjnB"};